var _Defs, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, ClipPath, Path, G, Circle } from "react-native-svg";
function SvgFlagJp(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "flag_jp_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fillOpacity: 0.7,
    d: "M-88 32h640v480H-88z"
  })))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    clipPath: "url(#flag_jp_svg__a)",
    transform: "translate(88 -32)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M-128 32h720v480h-720z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 523.1,
    cy: 344.1,
    r: 194.9,
    fill: "#bc002d",
    transform: "translate(-168.4 8.6) scale(.76554)"
  }))));
}
export default SvgFlagJp;